import { Button, Dropdown, Input, InputRef, message, Space, Table, TableProps, Tag, Tooltip, Upload } from 'antd'
import { FilterDropdownProps } from 'antd/es/table/interface';
import React, { useEffect, useRef, useState } from 'react'
import SearchIconSmall from '../../../components/icons/SearchIconSmall';
import SortIcon from '../../../components/icons/SortIcon';
import FileIcon from '../../../components/icons/FileIcon';
import { DOC_STATUS_CANCELLED, DOC_STATUS_PENDING_UPLOAD, DOC_STATUS_REQUESTED, DOC_STATUS_UPLOADED, STATUS_CANCELLED, STATUS_REQUESTED, STATUS_UPLOADED } from '../../../constants/constants';
import FilterIcon from '../../../components/icons/FilterIcon';
import FileIconSmall from '../../../components/icons/FileIconSmall';
import EyeIcon from '../../../components/icons/EyeIcon';
import DownloadIcon from '../../../components/icons/DownloadIcon';
import { uploadBrandDoc, uploadBrandMandatoryFile } from '../../../API/endpoints/Brands';
import { uploadProductDoc } from '../../../API/endpoints/Products';
import InfoIcon from '../../../components/icons/InfoIcon';
import ThreeDotsIcon from '../../../components/icons/ThreeDotsIcon';
import dayjs from 'dayjs';
import RequestDocModal from './RequestDocModal';
import { deleteDiscoveryDoc, getBrandRequestDocsByRequestId, updateDiscoveryDoc, uploadDiscoveryDoc } from '../../../API/endpoints/Discovery';
import DocInfoModal from './DocInfoModal';
import DeleteModalSimple from '../../Organization/components/DeleteModalSimple';
import PdfViewerModal from '../../components/Modal/PdfViewerModal';

interface Props {
    request: any;
    userProfile: any
}
const PartnerDocs = (props: Props) => {
    const { request, userProfile } = props

    const searchInput = useRef<InputRef>(null);

    const [messageApi, contextHolder] = message.useMessage();

    const [searchKey, setSearchKey] = useState("");
    const [pdfData, setPdfData] = useState<any>({});
    const [infoData, setInfoData] = useState<any>({});
    const [isDeleteItem, setIsDeleteItem] = useState<any>({});
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([])

    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const [dataFiltered, setDataFiltered] = useState<any[]>([]);

    const [isAddDoc, setIsAddDoc] = useState(false);
    const [isEditDoc, setIsEditDoc] = useState<any>({});

    useEffect(() => {
        if (request?.id) {
            setLoading(false);
            getBrandRequestDocsByRequestId(request?.id).then((res) => {
                setData(res?.data || []);
                setLoading(false);
            }).catch((err) => {
                setLoading(false);
                console.error('err', err);

            })
        }


    }, [request, reload])

    useEffect(() => {
        setDataFiltered((prev) => searchKey ? data?.filter((item: any) => item?.document_name?.toLowerCase().includes(searchKey?.toLowerCase())) : data)
    }, [data, searchKey])

    const handleSearch = (selectedKeys: any, confirm: any) => {
        confirm();
        if (selectedKeys[0] != undefined) {
            setSearchKey(selectedKeys[0]?.trim());
        }
    };

    const handleReset = (clearFilters: any, confirm: any) => {
        clearFilters();
        setSearchKey("");
        confirm();
    };

    const handleUploadFile = (data: any, file: any) => {
        if (!file) return;

        messageApi.open({
            key: "upload",
            type: "loading",
            content: "Document is uploading..."
        })
        const req = new FormData();
        req.append("file", file);

        uploadDiscoveryDoc(data?.id, req)
            .then(async () => {
                // onSuccessUploadAsset(data);
                const res = await updateDiscoveryDoc(data?.id, { status: DOC_STATUS_UPLOADED })
                messageApi.open({
                    key: "upload",
                    type: "success",
                    content: "Document uploaded successfully"
                })
                setReload(!reload);
            })
            .catch((err) => {
                console.error('Upload error:', err);
                messageApi.open({
                    key: "upload",
                    type: "error",
                    content: "Failed to upload doc. please try again!"
                })
            });
    };


    const downloadFile = (path: string) => {
        window.open(path, "_blank");
    };

    const onFilter = (filters: any) => {
        setSelectedStatuses(filters?.status || [])
    }


    const onSuccessAddDoc = (data: any) => {
        setReload(!reload)
        messageApi.success(isEditDoc?.name ? "Request updated successfully" : "Request added successfully");
        setIsEditDoc({});
        setIsAddDoc(false);

    }

    const onCancelAddDoc = () => {
        setIsEditDoc({});
        setIsAddDoc(false);
    }

    const onRequestCancellation = () => {
        messageApi.open({
            key: "cancel",
            type: "loading",
            content: "Reqaust Cancellation in progress..."
        })
        updateDiscoveryDoc(isDeleteItem?.id, { status: DOC_STATUS_CANCELLED }).then((res: any) => {
            setReload(!reload)
            messageApi.open({
                key: "cancel",
                type: "success",
                content: "Request cancelled successfully"
            })
            setIsDeleteItem({})
        }).catch((err) => {
            console.log('err', err);
            messageApi.open({
                key: "cancel",
                type: "error",
                content: "Failed to cancel request. Please try agin!"
            })
        });

    }

    const onSuccessDeleteAsset = () => {
        messageApi.success("Asset deleted successfully");
        const newList = data.filter((item: any) => item?.id !== isDeleteItem?.id)
        setData([...newList])
        setIsDeleteItem({});
    }

    const actionOptions = (record: any) => {
        let items: any = [];
        // items.push(
        //     {
        //         key: '1',
        //         label: "Edit",
        //         onClick: () => {
        //             if (record?.status === STATUS_REQUESTED) {
        //                 setIsEditDoc(record)
        //                 setIsAddDoc(true)
        //             } else {
        //                 setIsEditUploadAsset(record)
        //                 setIsUploadAsset(true)
        //             }

        //         }
        //     }
        // )

        items.push({
            key: '2',
            danger: true,
            label: record?.status === DOC_STATUS_REQUESTED ? "Cancel request" : "Delete",
            onClick: () => setIsDeleteItem(record)
        })

        return items;
    }



    const statusFilters = [
        {
            text: 'Pending Upload',
            value: STATUS_REQUESTED,
        },
        {
            text: 'Uploaded',
            value: "FILES",
        },
        {
            text: 'Cancelled',
            value: STATUS_CANCELLED,
        },
    ];

    const getColumnSearchProps = (dataIndex: any) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }: FilterDropdownProps) => (
            <div style={{ padding: 8 }}>
                <Input
                    classNames={{
                        input: "text-[12px]"
                    }}
                    ref={searchInput}
                    placeholder={`Search`}
                    value={selectedKeys[0]}
                    prefix={<SearchIconSmall />}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
                    className="mb-[8px]"
                />
                <div className="flex gap-2 justify-end">
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, confirm)}
                        size="small"
                        className="text-[12px]"
                    >Reset</Button>
                    <Button
                        type="primary"
                        title="Search"
                        size="small"
                        className="text-[12px]"
                        onClick={() => handleSearch(selectedKeys as string[], confirm)}
                    >Search</Button>
                </div>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchIconSmall color={filtered ? "#0152FB" : "#667085"} />
        ),
    });

    const columns: TableProps['columns'] = [
        {
            title: "Document / File Name",
            dataIndex: 'document_name',
            key: 'document_name',
            width: "25%",
            sorter: true,
            sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
            render: (text) => (
                <div className="flex gap-x-[10px] items-center">
                    <FileIcon />
                    <p className="m-0 text-[12px] font-[500]">{text}</p>
                </div>

            ),
            ...getColumnSearchProps("document_name")
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: "10%",
            filters: statusFilters,
            filterIcon: (filtered: boolean) => (
                <FilterIcon filtered={filtered} />
            ),
            render: (text, record: any) => {
                const statusText = text === DOC_STATUS_REQUESTED
                    && (
                        (userProfile?.partnerv2_id && record?.requestedUser?.partnerv2_id !== userProfile?.partnerv2_id) ||
                        (userProfile?.org_id && record?.requestedUser?.org_id !== userProfile?.org_id) ||
                        (userProfile?.id && record?.requestedUser?.id !== userProfile?.id)
                    )
                    ? DOC_STATUS_PENDING_UPLOAD : text
                return (
                    statusText !== DOC_STATUS_UPLOADED ? (
                        <Tag bordered={false} color={statusText === DOC_STATUS_REQUESTED ? "purple" : statusText === DOC_STATUS_PENDING_UPLOAD ? "warning" : "error"} className="rounded-[16px] capitalize">{statusText?.toLowerCase()}</Tag>
                    ) : (
                        record?.requestedBy || text === DOC_STATUS_UPLOADED ? (
                            <Tag bordered={false} color="success" className="rounded-[16px]">Uploaded</Tag>
                        ) : (
                            <></>
                        )

                    )
                )
            },
        },
        {
            title: 'Files',
            dataIndex: 'document',
            key: 'document',
            width: "20%",
            render: (document, record: any) => (
                document ? (
                    <Space>
                        <FileIconSmall />
                        <Tooltip title={record?.document_name}>
                            <p className="m-0 w-[154px] truncate text-[12px] leading-[12px]">{record?.document_name}</p>
                        </Tooltip>
                        <Button type="text" size="small" icon={<EyeIcon />} className="bg-[#EDEDED]" onClick={() => setPdfData({ path: document, name: record?.document_name })} />
                        <Button type="text" size="small" icon={<DownloadIcon />} className="bg-[#EDEDED]" onClick={() => downloadFile(document)} />
                    </Space>
                ) : (
                    <></>
                )

            )
        },
        {
            title: "Requested By",
            dataIndex: 'requested_by',
            key: 'requested_by',
            className: "capitalize"
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            width: "20%",
            align: "end",
            render: (_, record: any) => {
                const statusText = record?.status === DOC_STATUS_REQUESTED
                    && (
                        (userProfile?.partnerv2_id && record?.requestedUser?.partnerv2_id !== userProfile?.partnerv2_id) ||
                        (userProfile?.org_id && record?.requestedUser?.org_id !== userProfile?.org_id) ||
                        (userProfile?.id && record?.requestedUser?.id !== userProfile?.id)
                    )
                    ? DOC_STATUS_PENDING_UPLOAD : record?.status
                return (
                    <Space>
                        {record?.document || [DOC_STATUS_CANCELLED, DOC_STATUS_UPLOADED, DOC_STATUS_REQUESTED].includes(statusText) ? (
                            <></>
                        ) : (
                            <Upload
                                className="w-full upload-form-item"
                                onChange={(e: any) => handleUploadFile(record, e?.file,)}
                                beforeUpload={(file) => {
                                    return false
                                }}
                                showUploadList={false}
                            >
                                <Button type="primary" size="small" className="text-[12px] leading-[12px]" onClick={(e) => e.preventDefault()}>Upload</Button>
                            </Upload>
                        )}
                        {record?.status === DOC_STATUS_CANCELLED ? (
                            <></>
                        ) : (
                            <Dropdown menu={{ items: actionOptions(record) }}>
                                <Button icon={<ThreeDotsIcon />} type="text" className="leading-[12px]" onClick={(e) => e.preventDefault()} />
                            </Dropdown>
                        )}

                        <Button icon={<InfoIcon />} type="text" className="leading-[12px]" onClick={(e) => setInfoData(record)} />
                    </Space>

                )
            }
        },
    ]

    return (
        <div className="h-[calc(100vh-49px)] overflow-auto px-[16px]">
            {contextHolder}
            <div className='bg-white rounded-[8px] p-[16px]'>
                <div className="flex justify-end mb-[16px] stick">
                    <Button type="primary" onClick={(e) => setIsAddDoc(true)} >Request Doc</Button>
                </div>
                <Table
                    className="overflow-auto h-[calc(100%-32px)] w-full"
                    size="small"
                    rowKey={"id"}
                    columns={columns}
                    dataSource={dataFiltered}
                    loading={loading}
                    pagination={false}
                    onChange={(_: any, filters: any) => onFilter(filters)}

                />
            </div>
            <RequestDocModal
                request={request}
                open={isAddDoc}
                editData={isEditDoc}
                onCancel={() => onCancelAddDoc()}
                onSuccess={(data: any) => onSuccessAddDoc(data)}
                userProfile={userProfile}
            />
            <DocInfoModal
                title={"Info"}
                data={infoData}
                onClose={() => setInfoData({})}
            />
            <DeleteModalSimple
                title={isDeleteItem?.status === DOC_STATUS_REQUESTED ? "Doc Request" : "Doc"}
                content={isDeleteItem?.status === DOC_STATUS_REQUESTED ? "Are you sure you want to cancel this document request?" : "Are you sure you want to delete this document?"}
                okText={isDeleteItem?.status === DOC_STATUS_REQUESTED ? "Yes, Cancel" : "Yes, Delete"}
                item={isDeleteItem}
                onCancel={() => setIsDeleteItem({})}
                onSuccess={() => onSuccessDeleteAsset()}
                onOk={() => isDeleteItem?.status === DOC_STATUS_REQUESTED ? onRequestCancellation() : null}
                api={deleteDiscoveryDoc}
            />
            <PdfViewerModal
                pdfData={pdfData}
                isPdfOpen={Object.keys(pdfData).length > 0}
                closeModal={() => setPdfData({})}
            />
        </div>
    )
}

export default PartnerDocs